<template>
  <div>
    <el-form inline :model="searchData">
      <el-form-item>
        <el-input
          placeholder="备注"
          clearable
          prefix-icon="el-icon-search"
          v-model="searchData.searchInputValue"
          style="width: 250px"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="变动类型">
        <EnumSelect
          enumName="CustomerBalanceDetailChangeTypeEnum"
          :multiple="false"
          placeholder="请选择变动类型"
          v-model="searchData.changeTypeEnum"
          @change="changeAndSearch"
        ></EnumSelect>
      </el-form-item>
      <el-form-item label="变动金额">
        <NumberRangeInput
          :precision="2"
          :minVal.sync="searchData.minChangeAmount"
          :maxVal.sync="searchData.maxChangeAmount"
          @change="changeAndSearch"
        ></NumberRangeInput>
      </el-form-item>
      <el-form-item label="变动时间">
        <DateRangePicker
          :minVal.sync="searchData.minCreateDate"
          :maxVal.sync="searchData.maxCreateDate"
          @change="changeAndSearch"
        ></DateRangePicker>
      </el-form-item>
      <el-form-item>
        <el-button
          icon="el-icon-search"
          type="primary"
          size="mini"
          @click="changeAndSearch"
          :loading="searchLoading"
        >
          查询
        </el-button>
        <el-button
          icon="el-icon-refresh"
          size="mini"
          @click="resetAndSearch"
          :loading="searchLoading"
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="searchLoading"
      :data="searchRes && searchRes.data ? searchRes.data : []"
      stripe
      :row-key="
        (row) => {
          return row.id + row.lastEditTime;
        }
      "
      ref="refsTable"
      @sort-change="sortChange"
      max-height="400px"
    >
      <el-table-column
        prop="changeTypeEnum.Desc"
        label="变动类型"
        width="150"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="changeAmount"
        label="变动金额"
        width="150"
        align="center"
        header-align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <FmAmount change :amount="scope.row.changeAmount"></FmAmount>
        </template>
      </el-table-column>
      <el-table-column
        prop="afterChangeAmount"
        label="变动后余额"
        width="150"
        align="center"
        header-align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <FmAmount :amount="scope.row.afterChangeAmount"></FmAmount>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="250"
        align="left"
        header-align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="变动时间"
        width="200"
        align="center"
        header-align="center"
        sortable="custom"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="searchRes && searchRes.pageInfo"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchRes.pageInfo.page"
      :page-sizes="[5, 10, 20, 50, 100]"
      :page-size="searchRes.pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchRes.total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomerBalanceDetailSearchTable",
  props: {
    customerId: [String],
  },
  watch: {
    customerId: {
      handler(newVal, val) {
        this.searchRes = {};
        if (newVal) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      searchLoading: false,
      searchData: {
        changeTypeEnum: null,
        minChangeAmount: null,
        maxChangeAmount: null,
        minCreateDate: null,
        maxCreateDate: null,
      },
      searchParam: {
        quickSearchInfoList: [
          {
            // 备注
            columns: ["remark"],
            quickSearchValue: null,
          },
        ],
        customerId: null,
        changeTypeEnum: null,
        minChangeAmount: null,
        maxChangeAmount: null,
        minCreateDate: null,
        maxCreateDate: null,
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},
    };
  },

  mounted() {},

  methods: {
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.changeTypeEnum = this.searchData.changeTypeEnum;
      this.searchParam.minChangeAmount = this.searchData.minChangeAmount;
      this.searchParam.maxChangeAmount = this.searchData.maxChangeAmount;
      this.searchParam.minCreateDate = this.searchData.minCreateDate;
      this.searchParam.maxCreateDate = this.searchData.maxCreateDate;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      this.searchParam.customerId = this.customerId;
      let requestRes = await this.$api.customerBalanceDetail_findPageByCustomer(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CustomerBalanceDetailSearchTable.vue